import React from 'react';
import WeatherApp from './components/WeatherApp';

function App(){
  return (
    <div className="bg-slate-100 min-h-screen">
      <WeatherApp />
    </div>
  );
};

export default App;
